import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { provideComponentStore } from '@ngrx/component-store';
import { SellerBankData } from '../../../pages/create-seller-flow/create-seller-flow.store';
import { SellerBankDataStore } from './seller-seller-bank-data-store';

@Component({
  selector: 'app-seller-bank-data',
  templateUrl: './seller-bank-data.component.html',
  styleUrls: ['./seller-bank-data.component.scss'],
  providers: [provideComponentStore(SellerBankDataStore)],
})
export class SellerBankDataComponent {
  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<SellerBankData>();

  public formGroup = new FormGroup({
    bankCode: new FormControl<number | null>(null),
    bankBranch: new FormControl<string>(''),
    bankAccount: new FormControl<string>(''),
    terms: new FormControl<boolean>(false, Validators.requiredTrue),
  });

  constructor(public readonly cs: SellerBankDataStore) {}

  public submit() {
    this.next.emit({
      bankCode: this.formGroup.get('bankCode')!.value,
      bankBranch: this.formGroup.get('bankBranch')!.value,
      bankAccount: this.formGroup.get('bankAccount')!.value,
    });
  }

  public goBack() {
    this.back.emit();
  }
}
